import { cn } from "@/lib";
import React, { ComponentProps, FC } from "react";

const HeadLine: FC<ComponentProps<"h2">> = ({ children, ...rest }) => {
  return (
    <h2
      {...rest}
      className={cn(
        "md:text-md mb-5 w-full text-center text-xs md:mb-8",
        rest.className,
      )}
    >
      {children}
    </h2>
  );
};

export default HeadLine;
